export const NEW_INDEX_PATH = '/newIndex';

export function getNewIndexScrollContainer() {
  return document.querySelector('.ni-page') || document.scrollingElement || document.documentElement;
}

export function getNewIndexHeaderOffset() {
  const header = document.querySelector('.ni-header');
  return header ? header.offsetHeight : 0;
}

export function scrollNewIndexToHash(hash, behavior = 'smooth') {
  if (!hash) return false;

  const href = hash.startsWith('#') ? hash : `#${hash}`;
  const container = getNewIndexScrollContainer();

  if (href === '#home') {
    container.scrollTo({ top: 0, behavior });
    return true;
  }

  const el = document.getElementById(href.replace('#', ''));
  if (!el) return false;

  const headerOffset = getNewIndexHeaderOffset();
  const containerRect = container.getBoundingClientRect();
  const elTop = el.getBoundingClientRect().top - containerRect.top + container.scrollTop;

  container.scrollTo({
    top: Math.max(0, elTop - headerOffset),
    behavior,
  });

  return true;
}
